import { Navbar } from "./Navbar";
import { Outlet } from "react-router";
import Footer from "../ui-elements/Footer/Footer";

export const Container = () => {
  return (
    <div className="flex min-h-screen flex-col bg-light dark:bg-dark">
      <Navbar />
      <Outlet />
      <Footer />
    </div>
  );
};
